// BMR/TDEE quick-calculator (SummaryHero.js's "Calculate" button) — pure,
// no-persistence stand-in for the Working TDEE override (analysis.js's
// buildEnergyExpenditureStats), used when the coach wants a physiology-based
// starting point instead of (or before) the logged-data back-calc.
//
// Revised Harris-Benedict equation (Roza & Shizgal, 1984) — gives BMR, not
// TDEE; TDEE requires multiplying by an activity factor (see below).

export const ACTIVITY_MULTIPLIERS = [
  { key: "sedentary", factor: 1.2 },
  { key: "lightlyActive", factor: 1.375 },
  { key: "moderatelyActive", factor: 1.55 },
  { key: "veryActive", factor: 1.725 },
  { key: "extraActive", factor: 1.9 },
];

export const calculateBmr = ({ gender, ageYears, heightCm, weightKg }) => {
  const isFemale = gender === "female";
  const base = isFemale ? 447.593 : 88.362;
  const weightCoef = isFemale ? 9.247 : 13.397;
  const heightCoef = isFemale ? 3.098 : 4.799;
  const ageCoef = isFemale ? 4.33 : 5.677;
  return Math.round(base + weightCoef * weightKg + heightCoef * heightCm - ageCoef * ageYears);
};

export const calculateTdee = (bmr, activityFactor) => Math.round(bmr * activityFactor);
